import { useEffect, useState } from 'react';

/**
 * Tracks single-spa transitions where one app unmounts and another mounts,
 * so the shell can show a loader during the gap when #singleSpaRoot is empty.
 */
export const useSingleSpaAppTransition = (): boolean => {
  const [isAppTransitioning, setIsAppTransitioning] = useState(false);

  useEffect(() => {
    const onBeforeAppChange = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      const appsByNewStatus = detail?.appsByNewStatus;
      const willUnmount = appsByNewStatus?.NOT_MOUNTED?.length > 0;
      const willMount = appsByNewStatus?.MOUNTED?.length > 0;
      if (willUnmount && willMount) {
        setIsAppTransitioning(true);
      }
    };
    const onAppChange = () => setIsAppTransitioning(false);

    window.addEventListener('single-spa:before-app-change', onBeforeAppChange);
    window.addEventListener('single-spa:app-change', onAppChange);
    return () => {
      window.removeEventListener(
        'single-spa:before-app-change',
        onBeforeAppChange
      );
      window.removeEventListener('single-spa:app-change', onAppChange);
    };
  }, []);

  return isAppTransitioning;
};
